import React from "react";
import "./WhyChooseHomeShiksha.css";

import whyChooseImg1 from "../assets/why-choose/Feature 1.png";
import whyChooseImg2 from "../assets/why-choose/Feature 2.png";
import whyChooseImg3 from "../assets/why-choose/Feature 3.png";
import whyChooseImg4 from "../assets/why-choose/Feature 4.png";
import whyChooseImg5 from "../assets/why-choose/Feature 5.png";
import whyChooseImg6 from "../assets/why-choose/Feature 6.png";

const feature_list = [
  {
    id: 1,
    title: "Comprehensive Subject Offerings for Global Curriculums",
    description:
      "Wherever you are, HomeShiksha understands the importance of learning at a convenient time. We offer flexible scheduling to fit your local time zone, allowing students to plan sessions around their school or daily routine, making learning stress-free and enjoyable.",
  },
  {
    id: 2,
    title: "Curriculum-Specific Expertise Tailored to Your Country",
    description:
      "Our tutors are experienced in multiple international curricula, such as the IB, British, American, and other national standards. This ensures that students receive relevant support that aligns with their coursework, exams, and country-specific academic requirements, allowing them to excel in their studies.",
  },
  {
    id: 3,
    title: "Flexible Scheduling Across Global Time Zones",
    description:
      "I personally welcome you to the HomeShiksha community. We have more than 1.1L+ students and 1.8L+ tutors on-board and with you joining I hope that the community grows further strong.Meanwhile if you have any grievances or suggestion for improvement, I am all ears. Let me know by replying to nitin.jain@homeshiksha.com .",
  },
  {
    id: 4,
    title: "Instant Response and Global Support",
    description:
      "We understand that questions can arise at any time, which is why our support team operates around the clock. Whether you need help with booking a session, adjusting your schedule, or discussing your child’s progress, HomeShiksha’s support team is just a message or call away to provide prompt assistance, anytime.",
  },
  {
    id: 5,
    title: "Personalized, One-on-One Learning for Every Student",
    description:
      "Each student learns differently, and our one-on-one tutoring approach allows tutors to personalize lessons based on the student’s unique learning style, strengths, and areas for improvement. This individualized attention ensures more efficient learning, helping students build confidence and achieve their academic goals.",
  },
  {
    id: 6,
    title: "Dedicated Relationship Manager for Ongoing Support",
    description:
      "With HomeShiksha’s dedicated relationship manager, families receive consistent support and guidance throughout their learning journey. The manager helps with scheduling, monitors progress, provides feedback, and is there to answer any questions, ensuring a smooth and rewarding tutoring experience from start to finish.",
  },
];

const featureImages = [
  whyChooseImg1,
  whyChooseImg2,
  whyChooseImg3,
  whyChooseImg4,
  whyChooseImg6,
  whyChooseImg5,
];

function WhyChooseHomeShiksha() {
  return (
    <section className="why-choose-section" aria-labelledby="why-choose-heading">
      <div className="why-choose-container">
        <header className="why-choose-header">
          <h2 id="why-choose-heading" className="why-choose-title">
            Why To Choose <span className="why-choose-highlight">HomeShiksha</span>
          </h2>
        </header>

        <div className="why-choose-features">
          {feature_list.map((feature, index) => {
            const imageSrc = featureImages[index] || featureImages[0];

            return (
              <article
                key={feature.id}
                className={`why-choose-feature ${index % 2 === 1 ? "why-choose-feature--reverse" : ""
                  }`}
              >
                <div className="why-choose-feature__image" aria-hidden="true">
                  <img
                    src={imageSrc}
                    alt={feature.title}
                    className="why-choose-feature__image-img"
                  />
                </div>

                <div className="why-choose-feature__content">
                  <h3 className="why-choose-feature__title">
                    {feature.title}
                  </h3>
                  <p className="why-choose-feature__description">
                    {feature.description}
                  </p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseHomeShiksha;

